<template>
	<input type="checkbox" :checked="modelValue" @change="updateValue"/>
</template>

<script>
export default {
	name: "GuestInput",
	props: ["modelValue"],
	setup(props, {emit}){
		const updateValue = (event)=>{
			emit('update:modelValue', event.target.checked)
		}
		return {
			updateValue
		}
	}
}
</script>
